/* The masthead, lifted from the single-file build.
 *
 * Class names are the stylesheet's, not new ones — src/styles.css is the
 * original sheet and it styles .app-header, .brand, .header-tagline. Renaming
 * them is how a port ends up unstyled.
 */
export default function AppHeader({ children }) {
  return (
    <header className="app-header">
      <div className="brand">
        {/* AI Blueprints SVG Logo */}
        <svg className="brand-logo" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="AI Blueprints Logo">
          <rect x="2" y="2" width="28" height="28" rx="4" stroke="#66B2FF" strokeWidth="2" fill="none"></rect>
          <path d="M8 24V12l8-6 8 6v12" stroke="#66B2FF" strokeWidth="1.5" fill="none" strokeLinejoin="round"></path>
          <circle cx="16" cy="15" r="3" stroke="#fff" strokeWidth="1.5" fill="none"></circle>
          <line x1="16" y1="18" x2="16" y2="24" stroke="#fff" strokeWidth="1.5"></line>
          <line x1="12" y1="21" x2="20" y2="21" stroke="#66B2FF" strokeWidth="1" strokeDasharray="2 2"></line>
          <circle cx="16" cy="15" r="1" fill="#66B2FF"></circle>
        </svg>
        <div className="brand-text">
          <span className="brand-product">SentriPol™</span>
          <span className="brand-company">by AI Blueprints</span>
        </div>
      </div>
      {children || <span className="header-tagline">AI-Powered Insurance Policy Analysis Engine</span>}
    </header>
  );
}
